import React from 'react';
import { ArrowRight } from 'lucide-react';
import CountdownTimer from './CountdownTimer';
import { mockData } from '../mock/mockData';

const Hero = () => {
  const { hero } = mockData;

  return (
    <section className="hero-section">
      <div className="hero-content">
        <div className="hero-text-section">
          <h1 className="hero-title">{hero.title}</h1>
          <h2 className="hero-subtitle">{hero.subtitle}</h2>
          <p className="hero-tagline">{hero.tagline}</p>
          
          <div className="hero-countdown">
            <div className="countdown-container">
              <div className="countdown-launched">
                <h3 className="countdown-launched-text">LAUNCHING IN AUGUST</h3>
              </div>
            </div>
          </div>

          <a 
            href={hero.ctaLink} 
            className="btn-primary hero-cta"
            target="_blank"
            rel="noopener noreferrer"
          >
            {hero.ctaText}
            <ArrowRight size={20} />
          </a>
        </div>

        <div className="hero-image-section">
          <div className="hero-image-container">
            <img 
              src="https://customer-assets.emergentagent.com/job_3737a773-c919-4283-8e31-0559b71e3466/artifacts/m4e46pzo_Image.jpeg" 
              alt="Supreme Leader"
              className="hero-image"
            />
            <div className="hero-image-glow"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
